import { projectService, sessionService } from "@/app/providers/services";

const path = "/:id/investigations/:investigationId/cards/:cardId/state";
const projectEndpoint = projectService
  .endpoint()
  .bodyOf<Record<string, unknown>>()
  .paramsOf<"id" | "investigationId" | "cardId">()
  .responseOf<unknown>()
  .build({ id: "projectCardState", path, method: "post" });
const sessionEndpoint = sessionService
  .endpoint()
  .bodyOf<Record<string, unknown>>()
  .paramsOf<"id" | "investigationId" | "cardId">()
  .responseOf<unknown>()
  .build({ id: "sessionCardState", path, method: "post" });
/** Send an operation using parent-owned resource locators and the saved HTML digest. */
export async function executeCardState(
  scope: "project" | "session",
  id: string,
  investigationId: string,
  cardId: string,
  input: Record<string, unknown>,
): Promise<unknown> {
  const response = await (scope === "project" ? projectEndpoint : sessionEndpoint).submit({
    params: { id, investigationId, cardId },
    body: input,
  });
  return response.data;
}
